/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChatRetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB00lEQVR4nN2VPUscURSGjaiBgI2IJvgvYqfFlq7unI8r3D1nE+utRUTRZsFCLFSsrZMQUosIKqJi4V8wCptOCxf8QEVBw50ddXFWZ2Z3KwdOMTOX97nnve+ZaWp611c6nf6IRiyS/EKSI2A9B9IrID0E0h/uXSqVaqlJHFiGkaSIrA8R9Q9YKIn2ByBdiiH8UFlAulAoFJrj7HwxqThWQN4U9yjHtYpjUE6jqng+n291ftYLQJKi0woB0GS1bnEOyoit4r3+bhQAWH+GAaSHDeuA9W/YItabxgHkMgwguU4eSzlB1jnmb73GjHQhYjuR9Hksg9UAR8nSoqvW2o63Yv8CoH8S7HzlcWrBaBpY1pClBKQXyLpBlB0A1j0k2a0hpnLsebnO4NxmotY/Aay1bbFsIpl164lyQ8GzO49k3EEzGdsDJNNAchsClKMqk1EAz2S/BnOzHtg1WTFLe6924HaAJAeRAK9sD5Ceuntjvn+pCMrui4HbCcS9T0CyH+sMENvL/kvJFwHtjkwQkCzHTtBwtj+wY6tskU7E/QfcxwEQifhdP3/a79w5DFn72beZZQxZzoB1KhIcdSHL/OuzoqN1A3wIqgHWbdeJXySbaDTzuOA/XoahkApIALUAAAAASUVORK5CYII=)
 */
export const ChatRetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M19 16A3 3 0 1 0 21 21.25a1 1 0 1 1 1.32 1.5A4.98 4.98 0 0 1 14 19a5 5 0 0 1 8-4 1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h1.23A3 3 0 0 0 19 16Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M22 12c0 .1-.06.2-.16.23l-.19.09a.58.58 0 0 1-.44.04 7 7 0 0 0-8.8 9c.1.3-.09.64-.4.64H2.2a1 1 0 0 1-.76-1.66l2.07-2.37a.52.52 0 0 0 .04-.61A10 10 0 1 1 22 12Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
